import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/service'

// Modules
import service from './service'

const initialState = () => ({
    services: {
        data: [],
        pagination: {}
    },
    allServices: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        services: state => state.services.data,
        allServices: state => state.allServices.data,
        pagination: state => state.services.pagination,
        allPagination: state => state.allServices.pagination
    },
    actions: {
        listServices: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listServices(data)
                const services = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_SERVICES, services)
                return services
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        listServicesFull: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listServicesFull(data)
                commit(mutationTypes.SET_ALL_SERVICES, response.data)

                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetServices: ({commit}) => commit(mutationTypes.RESET_SERVICES),
        resetAllServices: ({commit}) => commit(mutationTypes.RESET_ALL_SERVICES)
    },
    modules: {
        service
    },
    mutations: {
        [mutationTypes.RESET_ALL_SERVICES]: (state) => state.allServices = initialState().allServices,
        [mutationTypes.RESET_SERVICES]: (state) => state.services = initialState().services,
        [mutationTypes.SET_ALL_SERVICES]: (state, data) => state.allServices = data,
        [mutationTypes.SET_SERVICES]: (state, data) => state.services = data
    }
}
